import { start, dt } from "lib/loop";
import { preloader } from "./preloader";
import { audio, input, ctx, layout } from "shared";
import { loadI18n, detectLocale, setLocale, cycleLocale } from "i18n";
import { loadAudio, initLiftSounds } from "audio";
import { loadImages } from "game/images";
import { loadFonts } from "./fonts";
import { render, initRender } from "game/render";
import { update } from "game/update";
import { gameState } from "game/state";
import { nextZone } from "game/terrain";
import { copter } from "game/copter";
import { landscape } from "game/terrain";
import { camera } from "game/camera";
import { background } from "game/background";
import { hud } from "game/hud";
import { curtains } from "game/curtains";
import { bonusLayout } from "game/bonus-layout";
import { menu } from "game/update";

const unlockAudio = () => audio.unlock();

export function boot(): void {
  start(gameUpdate, gameRender);

  preloader.onAppLoaded = () => {
    gameState.loaded = true;
    setLocale(detectLocale(navigator.language));

    input.onCheatKey = (key: string) => {
      if (key === "l" || key === "L") {
        const next = cycleLocale();
        console.log(`[cheat] locale → ${next}`);
      }
    };

    document.addEventListener("pointerdown", unlockAudio, { once: true });
    document.addEventListener("touchstart", unlockAudio, { once: true });

    initRender();
    initLiftSounds();
    initGame();
  };

  preloader.total += 2;
  loadI18n().then(() => preloader.complete());
  loadAudio().then(() => preloader.complete());
  for (const p of loadImages()) {
    ++preloader.total;
    p.then(() => preloader.complete());
  }
  for (const p of loadFonts()) {
    ++preloader.total;
    p.then(() => preloader.complete());
  }
}

function initGame(): void {
  nextZone();
  landscape.reset();
  copter.reset();
  camera.reset(copter.wx);
  landscape.syncFrame(camera.x);
  background.reset();
  hud.reset();
  bonusLayout.firstPlace();
  menu.reset();
  curtains.open();
}

function gameUpdate(): void {
  if (!gameState.loaded) {
    preloader.update();
    return;
  }

  input.update();
  update(dt);
  input.clearFrameEvents();
}

function gameRender(): void {
  if (!gameState.loaded) return;
  render(ctx, layout);
}
